/* 列傳選單點一章時的「圖解」：交戰雙方、前情、結果與影響（只寫正史；裴注要標出處，演義不放）
 * 鍵是列傳選單上的章節 id（分幕的章寫第一幕）。格式見 src/campaign/bg/index.ts。 */
// @ts-nocheck
export default {
  'ganning-1': {
    sides: [
      { f: 'wu', n: '孫權', l: '凌操（輕舟先登）', w: 1 },
      { f: 'lbiao', n: '黃祖', l: '黃祖、甘寧（斷後）' },
    ],
    before: '甘寧少年是巴郡游俠，身上掛鈴，人聽到鈴聲就知道他來了。他帶著部眾先投劉表、再投江夏太守黃祖，黃祖只把他當平常人看待。建安八年孫權西征黃祖，打敗了黃祖的水軍。',
    after: '黃祖敗逃時，甘寧在後面斷後，射死追來的吳將凌操，黃祖因此脫身，卻仍不重用他（《吳書》）。孫權這次沒攻下城就回去了（〈吳主傳〉）。後來都督蘇飛說情，讓甘寧去當邾長，他就帶著幾百人投奔孫權。',
    src: '《三國志·吳書·甘寧傳》及注引《吳書》；〈凌統傳〉〈吳主傳〉',
  },
  'ganning-2': {
    sides: [
      { f: 'wu', n: '周瑜', l: '甘寧（守夷陵）、周瑜、呂蒙（解圍）', w: 1 },
      { f: 'wei', n: '曹仁', l: '曹仁派五六千人圍城' },
    ],
    before: '赤壁之後，周瑜進攻南郡的曹仁，一時攻不下。甘寧建議先取上游的夷陵，帶著幾百人一到就拿下城。曹仁立刻派五六千人回頭圍他，城裡連新收的兵也才一千人。',
    after: '曹軍起高樓往城裡射箭，眾人都怕，只有甘寧談笑自若。周瑜採呂蒙的計策，留凌統守後方、親自來救，殺敵過半；逃走的曹騎撞上預先用柴木塞住的險道，吳軍得馬三百匹。之後曹仁退出南郡。',
    src: '《三國志·吳書·甘寧傳》；〈周瑜傳〉〈呂蒙傳〉',
  },
  'ganning-3': {
    sides: [
      { f: 'wu', n: '孫權', l: '呂蒙、甘寧（升城督）', w: 1 },
      { f: 'wei', n: '曹操', l: '朱光（廬江太守）；張遼（援軍）' },
    ],
    before: '曹操派朱光當廬江太守，屯在皖城大開稻田，還派人去招誘鄱陽的山賊。呂蒙認為等稻子收成就難打了，勸孫權親征，並主張趁雨水還沒退四面急攻，不造土山（《吳書》）。呂蒙推薦甘寧當升城督，帶頭爬城。',
    after: '甘寧手持繩索爬上城牆，替士卒開路；呂蒙擂鼓，全軍一早進攻，吃早飯的時候就破城，抓到朱光。張遼的援軍走到夾石，聽說城已經丟了就退回去。論功呂蒙第一、甘寧第二，甘寧拜折衝將軍。',
    src: '《三國志·吳書·甘寧傳》；〈呂蒙傳〉及注引《吳書》',
  },
  'ganning-4': {
    sides: [
      { f: 'wu', n: '孫權', l: '魯肅、甘寧（一千三百人）', w: 1 },
      { f: 'shu', n: '劉備', l: '關羽（自選銳士五千）' },
    ],
    before: '孫權和劉備爭荊州三郡，魯肅屯益陽擋關羽。關羽號稱三萬人，親選五千銳士，要從縣城上游十幾里的淺灘夜裡涉水過河。甘寧手下只有三百人，向魯肅再要五百，說關羽聽到他咳一聲就不敢下水；魯肅給了他一千人。',
    after: '甘寧連夜趕去，關羽聽說之後停下不渡，就地紮起柴營，那處淺灘從此叫「關羽瀨」。孫權嘉獎甘寧，拜他為西陵太守，兼領陽新、下雉兩縣。',
    src: '《三國志·吳書·甘寧傳》；〈呂蒙傳〉',
  },
};
